export enum ProcessTaskStatus {
  Pending = 1,
  Overdue = 2,
  MarkedAsDone = 3,
  WindowClosed = 4,
  Flagged = 'flagged',
  AuditFailed = 5,
  upcoming = 6,
}

export enum AuditStatus {
  Completed = 1,
  Failed = 2,
}
